import { Application } from '../App';
import { CalculatorApplication, IApplicationProps } from '../CalculatorApp';

export const RootApplicationContainer: React.FC<IApplicationProps> = props => {
  switch (props.context.custom.pageType) {
    case 'landing':
      return <Application {...props} />;

    case 'calculator':
      return <CalculatorApplication {...props} />;

    default:
      throw new Error('Unknown context.custom.pageType');
  }
};
